// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 27174 ? "6433faf4" : chunkId) + "." + {"22991":"30de280712b82dc6","27174":"a1f15ebedc98ec9e","53348":"c261bc9d631915a8","85417":"460c8cab802964dd"}[chunkId] + ".js";
};